/**
 * @generated SignedSource<<f17067f8c56faf18dd1aa05c93825a60>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueViewReporterField_servicedeskCustomerServiceCustomFields_JCSReporterFieldInner$data = {
  readonly user: {
    readonly accountId: string;
    readonly name: string;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"reporterField_servicedeskCustomerServiceCustomFields">;
  readonly " $fragmentType": "issueViewReporterField_servicedeskCustomerServiceCustomFields_JCSReporterFieldInner";
};
export type issueViewReporterField_servicedeskCustomerServiceCustomFields_JCSReporterFieldInner$key = {
  readonly " $data"?: issueViewReporterField_servicedeskCustomerServiceCustomFields_JCSReporterFieldInner$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueViewReporterField_servicedeskCustomerServiceCustomFields_JCSReporterFieldInner">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "issueViewReporterField_servicedeskCustomerServiceCustomFields_JCSReporterFieldInner",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "reporterField_servicedeskCustomerServiceCustomFields"
    },
    {
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "accountId"
        },
        {
          "kind": "ScalarField",
          "name": "name"
        }
      ]
    }
  ],
  "type": "JiraSingleSelectUserPickerField"
};

(node as any).hash = "b5df2549fe8268f7deaf7f8bd35a5d8b";

export default node;
